import { Component, Input, OnInit } from '@angular/core';

import { IParty } from '@tablesready/common-ui';
import { AppIcon, AppIconColor } from '@tablesready/frontend-icons';

export interface WaitlistActionsCallbacks<T> {
  addEditParty: (party: T) => void;
  checkPartyResources: (party: T) => void;
  confirmDelete: (party: T) => void;
  chatParty: (party: T, index: number) => void;
}

@Component({
  selector: 'tablesready-waitlist-actions',
  templateUrl: './waitlist-actions.component.html',
  styleUrls: ['./waitlist-actions.component.scss'],
})
export class WaitlistActionsComponent implements OnInit {
  @Input() togoMode = false;
  @Input() party?: IParty;
  @Input() index = 0;
  @Input() isMobile = false;
  @Input() callbacks?: WaitlistActionsCallbacks<IParty>;

  chatBtnFocus: Record<number, boolean> = { };
  icon = AppIcon;
  color = AppIconColor;

  ngOnInit(): void {}

  chatTooltip(phoneNumber?: string): string {
    if (this.isMobile) {
      return '';
    }

    return !phoneNumber ? 'No phone provided' : 'Chat';
  }
}
